var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import { Table } from 'template/lib';
import styles from './styles.module.scss';
var formatSize = function (bytes) {
    if (bytes >= Math.pow(1024, 3))
        return (bytes / Math.pow(1024, 3)).toFixed(2) + " GB";
    if (bytes >= Math.pow(1024, 2))
        return (bytes / Math.pow(1024, 2)).toFixed(1) + " MB";
    return Math.ceil(bytes / 1024) + " KB";
};
// A API devolve a data em UTC; sem o "Z" o navegador a trataria como hora local.
var formatDate = function (utc) { return new Date(utc.endsWith('Z') ? utc : utc + "Z").toLocaleString('pt-BR'); };
var BackupDownload = function () {
    var login = useAuth().login;
    var setTitle = useTitle().setTitle;
    var _a = useState([]), files = _a[0], setFiles = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(15), pageSize = _c[0], setPageSize = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var config = { headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) } };
    useEffect(function () {
        setTitle('Backups');
        api.get("/backups/companies/" + (login === null || login === void 0 ? void 0 : login.companyId), config)
            .then(function (response) { return setFiles(response.data); })
            .catch(function () { return alert('Não foi possível carregar os backups.'); })
            .finally(function () { return setLoading(false); });
    }, []);
    // A API já ordena do mais novo ao mais antigo. O id da linha é o índice na lista completa.
    var rows = files.map(function (file, index) { return ({
        id: index,
        database: file.database,
        fileName: file.fileName,
        size: formatSize(file.sizeBytes),
        uploadedAt: formatDate(file.uploadedAtUtc)
    }); });
    var totalPages = Math.ceil(rows.length / pageSize);
    var download = function (id) {
        var file = files[id];
        api.get("/backups/companies/" + (login === null || login === void 0 ? void 0 : login.companyId) + "/download", __assign(__assign({}, config), { params: { database: file.database, fileName: file.fileName } }))
            .then(function (response) { window.location.href = response.data.url; })
            .catch(function () { return alert('Não foi possível gerar o link de download.'); });
    };
    var lineBtns = [
        {
            name: 'Baixar',
            icon: _jsx(FiDownload, { size: 16 }, void 0),
            fn: download
        }
    ];
    return (_jsx("div", __assign({ className: styles.container }, { children: _jsx("div", __assign({ className: styles.content }, { children: _jsx(Table, { setSize: setPageSize, size: pageSize, hasNext: page < totalPages, page: page, setPage: setPage, data: rows.slice((page - 1) * pageSize, page * pageSize), totalPAges: totalPages, lineButton: lineBtns, loading: loading, title: "Backups", columns: [
                    { label: 'Base', key: 'database' },
                    { label: 'Arquivo', key: 'fileName' },
                    { label: 'Tamanho', key: 'size' },
                    { label: 'Enviado em', key: 'uploadedAt' }
                ] }, void 0) }), void 0) }), void 0));
};
export default BackupDownload;
